import { render, staticRenderFns } from "./LanguageHeaderThemes.vue?vue&type=template&id=5c5e8a14&scoped=true"
import script from "./LanguageHeaderThemes.vue?vue&type=script&lang=ts"
export * from "./LanguageHeaderThemes.vue?vue&type=script&lang=ts"
import style0 from "./LanguageHeaderThemes.vue?vue&type=style&index=0&id=5c5e8a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e8a14",
  null
  
)

export default component.exports